import { render, staticRenderFns } from "./OrgCasesResolvedByMonth.vue?vue&type=template&id=e9689590&"
import script from "./OrgCasesResolvedByMonth.vue?vue&type=script&lang=js&"
export * from "./OrgCasesResolvedByMonth.vue?vue&type=script&lang=js&"
import style0 from "./OrgCasesResolvedByMonth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports